/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Ar as Ar,
  rec_FiltrosOrganigrama as FiltrosOrganigrama,
  rec_JSXRuntime as JSXRuntime,
  rec_Mr as Mr,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function PuestoOrganigrama(e) {
  let t = (0, ReactCompiler.c)(33),
    { nodo: n, cerrados: r, onAlternar: i, onAbrir: a, resaltado: o } = e,
    s = n.hijos.length > 0,
    c;
  t[0] !== r || t[1] !== n.fila.id || t[2] !== s
    ? ((c = s && !r.has(n.fila.id)),
      (t[0] = r),
      (t[1] = n.fila.id),
      (t[2] = s),
      (t[3] = c))
    : (c = t[3]);
  let l = c,
    u = s ? l : void 0,
    d;
  t[4] !== l ||
  t[5] !== n.fila.id ||
  t[6] !== n.hijos.length ||
  t[7] !== i ||
  t[8] !== s
    ? ((d = s ? (
        <button
          type={`button`}
          onClick={() => i(n.fila.id)}
          aria-label={`${l ? `Cerrar` : `Abrir`} a quienes reportan a este puesto (${n.hijos.length})`}
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-(--text) hover:bg-(--accent-bg) hover:text-(--text-h)`}
          children={
            l ? <Ar className={`h-4 w-4`} /> : <Mr className={`h-4 w-4`} />
          }
        />
      ) : (
        <span className={`w-11 shrink-0`} aria-hidden={`true`} />
      )),
      (t[4] = l),
      (t[5] = n.fila.id),
      (t[6] = n.hijos.length),
      (t[7] = i),
      (t[8] = s),
      (t[9] = d))
    : (d = t[9]);
  let f = o === n.fila.id,
    p;
  t[10] !== n.fila || t[11] !== a || t[12] !== f
    ? ((p = (
        <div
          className={`min-h-[68px] w-full max-w-md min-w-0`}
          children={
            <FiltrosOrganigrama fila={n.fila} onAbrir={a} resaltada={f} />
          }
        />
      )),
      (t[10] = n.fila),
      (t[11] = a),
      (t[12] = f),
      (t[13] = p))
    : (p = t[13]);
  let m;
  t[14] !== n.hijos.length || t[15] !== s
    ? ((m = s && (
        <span
          className={`shrink-0 rounded-full bg-(--panel-fuerte) px-2 py-0.5 text-xs text-(--text)`}
          title={`Personas a su cargo`}
          children={n.hijos.length}
        />
      )),
      (t[14] = n.hijos.length),
      (t[15] = s),
      (t[16] = m))
    : (m = t[16]);
  let h;
  t[17] !== n.fila.id || t[18] !== d || t[19] !== p || t[20] !== m
    ? ((h = (
        <div
          className={`flex items-center gap-1`}
          data-puesto={n.fila.id}
          children={[d, p, m]}
        />
      )),
      (t[17] = n.fila.id),
      (t[18] = d),
      (t[19] = p),
      (t[20] = m),
      (t[21] = h))
    : (h = t[21]);
  let _;
  t[22] !== l ||
  t[23] !== r ||
  t[24] !== n.hijos ||
  t[25] !== a ||
  t[26] !== i ||
  t[27] !== o
    ? ((_ = l && (
        <ul
          role={`group`}
          className={`ml-5 flex flex-col gap-2 border-l-2 border-(--border) pl-3 sm:ml-[1.35rem] sm:pl-5`}
          children={n.hijos.map((e) => (
            <PuestoOrganigrama
              key={e.fila.id}
              nodo={e}
              cerrados={r}
              onAlternar={i}
              onAbrir={a}
              resaltado={o}
            />
          ))}
        />
      )),
      (t[22] = l),
      (t[23] = r),
      (t[24] = n.hijos),
      (t[25] = a),
      (t[26] = i),
      (t[27] = o),
      (t[28] = _))
    : (_ = t[28]);
  let v;
  return (
    t[29] !== u || t[30] !== h || t[31] !== _
      ? ((v = (
          <li
            role={`treeitem`}
            aria-expanded={u}
            className={`flex flex-col gap-2`}
            children={[h, _]}
          />
        )),
        (t[29] = u),
        (t[30] = h),
        (t[31] = _),
        (t[32] = v))
      : (v = t[32]),
    v
  );
}
